import React, { ReactElement } from 'react';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import { APP_TYPE_ANY } from './src/types/common.types';

type PropTypes = {
  children: React.ReactNode;
  reCaptchaKey: string;
};

export const WrapWithGoogleReCaptchaProvider = (
  props: PropTypes
): ReactElement => {
  const { children, reCaptchaKey = '' } = props;

  if (!reCaptchaKey) {
    return <>{children}</>;
  }

  return (
    <>
      {(GoogleReCaptchaProvider as APP_TYPE_ANY)({
        reCaptchaKey: reCaptchaKey,
        scriptProps: {
          async: true,
          defer: false
        },
        children
      })}
    </>
  );
};
